import { useSelector } from 'react-redux';

import CmsContent, { TRenderCmsContent } from '@@/auto/components/CmsContent';
import { getIsLoggedIn } from '@@/auto/store/selectors';
import TenantPhoneLink from '@@/common/components/TenantPhoneLink';
import { useConfig } from '@@/common/services/useConfig';

import Footer, { TFooter } from './Footer';
import classes from './Footer.module.css';

export default function FooterForTenant(
  props: { isAccountView?: boolean } & Omit<
    TFooter,
    | 'cmsContent'
    | 'hasNavItems'
    | 'hasPersonalInfoLink'
    | 'hasSocialLinks'
    | 'sureFooterLogoSrc'
    | 'phoneLink'
    | 'tenantPhoneVariant'
  >
) {
  const {
    config: {
      cmsSlugs: { authenticatedFooterSlug, footerSlug, copyrightSlug },
      footerConfig,
    },
  } = useConfig();

  const isLoggedIn = useSelector(getIsLoggedIn);
  const { isAccountView, ...otherProps } = props;
  const hasPersonalInfoLink = !isLoggedIn || !isAccountView;
  const footerCmsSlug = isAccountView ? authenticatedFooterSlug : footerSlug;
  const cmsContentTestId = isAccountView
    ? 'footer-disclaimer-account'
    : 'footer-disclaimer';

  const renderCmsContent: TRenderCmsContent = ({ cmsContent, parseHTML }) =>
    parseHTML(cmsContent?.fields?.[0]?.text || '');

  return (
    <Footer
      {...otherProps}
      {...footerConfig}
      hasPersonalInfoLink={hasPersonalInfoLink}
      phoneLink={<TenantPhoneLink className={classes.tenantPhone} />}
      cmsContent={
        <>
          <CmsContent
            modelSlug="copyright"
            entrySlug={copyrightSlug}
            data-testid={`${cmsContentTestId}-copyright`}
            renderContent={renderCmsContent}
          />
          <br />
          <CmsContent
            modelSlug="footer"
            entrySlug={footerCmsSlug}
            data-testid={cmsContentTestId}
            renderContent={renderCmsContent}
          />
        </>
      }
    />
  );
}
export * from './Footer';
